export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://stgchat.shopchat.it/api/v1',
  chatUrl: 'https://stgchat.shopchat.it/chat',
  google_client_id: '34997516099-lau0p5orotqnq8r98jjlg0etp3getulv.apps.googleusercontent.com'
};
